module.exports = __webpack_public_path__ + "img/driverChami .e83ea1d9.png";